import { render, staticRenderFns } from "./PlayMyItems.vue?vue&type=template&id=eb6d7208&"
import script from "./PlayMyItems.vue?vue&type=script&lang=js&"
export * from "./PlayMyItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports